import React, { useState, useEffect, useRef } from "react";
import {
  colors,
  boxesData,
  desktopPaths,
  mobilePaths,
} from "../assets/flowData/path";
import "../components/flowDiagram.css";
const FlowDiagram = () => {
  const [viewBox, setViewBox] = useState("0 0 1000 1300");
  const [isVisible, setIsVisible] = useState(false);
  const diagramRef = useRef(null);
  const [platformClass, setPlatformClass] = useState("");

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/android/i.test(userAgent)) {
      setPlatformClass("android");
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      setPlatformClass("ios");
    } else {
      setPlatformClass("web");
    }
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setViewBox(window.innerWidth <= 768 ? "0 0 800 3300" : "0 0 1000 1220");
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const diagramElement = diagramRef.current;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.1 }
    );

    if (diagramElement) {
      observer.observe(diagramElement);
    }

    return () => {
      if (diagramElement) {
        observer.unobserve(diagramElement); // Use the stored variable in cleanup
      }
    };
  }, []);

  // const getGradient = (color) =>
  //   `linear-gradient(135deg, ${color}50 0%, ${color} 100%)`;

  const renderPaths = (paths, className) =>
    paths.map((line, index) => (
      <path
        key={index}
        d={line.path}
        className={`animate-draw-line ${className}`}
        style={{
          stroke: colors[line.color],
          animationDelay: line.delay,
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "0.7%",
          fill: "none",
        }}
      />
    ));
  const renderBoxes = (isDesktop) =>
    boxesData.map((box, index) => {
      const { x, y } = isDesktop ? box.desktop : box.mobile;
      const width = isDesktop ? "240" : "740";
      const height = isDesktop ? "240" : "420";
      const className = isDesktop ? "hidden md:block" : "md:hidden";
      const delay = isDesktop ? `${index * 1.5 + 0}s` : `${index + 0.5}s`;
      return (
        <foreignObject
          key={index}
          x={x}
          y={y}
          width={width}
          height={height}
          className={`animate-fade-in foreign-object ${className}`}
          style={{
            animationDelay: delay,
            ...(isDesktop
              ? {}
              : {
                  border: `12px solid ${colors[box.color]}`,
                  borderRadius: "40px",
                }),
          }}
        >
       <div
          xmlns="http://www.w3.org/1999/xhtml"
          className={`box-container ${isDesktop ? "" : "rounded-3xl"}`}
          style={{ 
            backgroundColor: `${colors[box.color]}20`,
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center',
            justifyContent: 'center', 
            height: '100%',
          }}
        >
          {platformClass !== "ios" && (
            <div
              className="box-number"
              style={{
                backgroundColor: colors[box.color],
                color: colors.white,
                marginRight: 5,
              }}
            >
              {box.number}
            </div>
          )}
          <div className={`box-title ${isDesktop ? "md:text-base" : ""}`}>
            {box.title}
          </div>
          <div className={`box-description ${isDesktop ? "md:text-sm" : ""}`}>
            {box.description}
          </div>
        </div>
        </foreignObject>
      );
    });

  return (
    <div
      ref={diagramRef}
      className="flow-diagram"
      style={{ overflow: "hidden" }}
    >
      <svg
        className="flow-diagram-svg"
        viewBox={viewBox}
        fill="none"
        preserveAspectRatio="xMidYMid meet"
      >
        {isVisible && renderPaths(desktopPaths, "hidden md:block")}
        {isVisible && renderPaths(mobilePaths, "md:hidden lg:hidden")}
        {isVisible && renderBoxes(true)}
        {isVisible && renderBoxes(false)}
      </svg>
    </div>
  );
};

export default FlowDiagram;
